"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var changes_1 = require("../changes");
var utils_1 = require("../utils");
/**
 * User pressed Enter in an editor
 *
 * Enter in a list item should split the list item
 * Enter in an empty list item should remove it
 * Shift+Enter in a list item should make a new line
 */
function onEnter(event, editor, opts, next) {
    // Pressing Shift+Enter
    // should split block normally
    if (event.shiftKey) {
        return next();
    }
    var value = editor.value;
    var currentItem = utils_1.getCurrentItem(opts)(value);
    // Not in a list
    if (!currentItem) {
        return next();
    }
    event.preventDefault();
    // If expanded, delete first.
    if (value.selection.isExpanded) {
        editor.delete();
    }
    if (currentItem.nodes.every(function (node) { return node.text === ''; })) {
        // Block is empty, we exit the list
        if (utils_1.getItemDepth(opts)(value) > 1) {
            return changes_1.decreaseItemDepth(opts, editor);
        }
        // Exit list
        return changes_1.unwrapList(opts, editor);
    }
    // Split list item
    return changes_1.splitListItem(opts, editor);
}
exports.default = onEnter;
//# sourceMappingURL=onEnter.js.map